<div *ngIf="questionsArray">
  <div class="mt-4 p-4" *ngIf="!isLocked">
    <p class="mb-2 font-semibold text-xl">
      Please answer all the following questions. “Yes” responses to questions 2-13 require a
      detailed written explanation. Attach additional pages to this application with responses.
      Failure to attach additional pages may result in a delay in certifications. (Required for all
      certifications)
    </p>
  </div>

  <div class="mt-4" *ngIf="isRenewal">
    <p class="font-semibold text-xl">
      For a renewal, answer the questions based only on the time since your last certification.
    </p>
  </div>

  <div class="mt-4" *ngFor="let questionGroup of questionsArray.controls as FormGroup; let i = index" [formGroup]="questionGroup">
    <div class="question-container" [ngClass]="{ 'extra-space': questionGroup.get('parentId')?.value === null }">
      <div class="question-text pb-4" *ngIf="questionGroup.get('questionId')?.value == 12">
        <mat-label>
          <span class="question-number">{{ i + 1 }}.</span>
          Have you ever been found in a civil, administrative, or criminal proceeding to have:
        </mat-label>
      </div>

      <div class="question-text">
        <mat-label [ngClass]="{ 'indented-label': questionGroup.get('parentId')?.value !== null }">
          <span class="question-number" *ngIf="questionGroup.get('parentId')?.value === null">{{ i < 13 ? i + 1 : i - 1 }}.</span>
          <span class="sub-question-number" *ngIf="questionGroup.get('parentId')?.value !== null">{{ getSubQuestionNumber(i) }}</span>
          {{ questionGroup.get('questionText')?.value }}
        </mat-label>
      </div>

      <!-- Radio Buttons for Yes/No -->
      <div class="radio-buttons" [ngClass]="{ 'indented-label': questionGroup.get('parentId')?.value !== null }">
        <mat-radio-group formControlName="yesNo" (change)="onYesNoChange(i)">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
          <mat-error *ngIf="questionGroup.get('yesNo')?.hasError('required') && questionGroup.get('yesNo')?.touched">
            {{'Please select Yes or No for question ' + (i < 13 ? i + 1 : i - 1) + '.'}}
          </mat-error>
        </mat-radio-group>
      </div>

      <!-- Special case: Show URL instead of comment box for a specific question -->
          <!-- <div *ngIf="questionGroup.get('yesNo')?.value === true && questionGroup.get('questionText')?.value?.includes('Fieldprint Electronic Fingerprinting Instructions')" class="info-link">
            <a href="https://www.oregon.gov/oha/PH/PROVIDERPARTNERRESOURCES/HEALTHCAREPROVIDERSFACILITIES/HEALTHCAREHEALTHCAREREGULATIONQUALITYIMPROVEMENT/Documents/HemoFieldprintInstructions.pdf"
              target="_blank">
              Please see 'Fieldprint Electronic Fingerprinting Instructions' on our website for additional instructions.
            </a>
          </div> -->

      <!-- Show the comment field only when Yes is selected (except for the special question) -->
      <mat-form-field *ngIf="questionGroup.get('yesNo')?.value === true &&
                      !questionGroup.get('questionText')?.value?.includes('outside of Oregon')"
                      appearance="fill"
                      [ngClass]="{ 'indented-label': questionGroup.get('parentId')?.value !== null }" class="full-width">
        <mat-label>Comment</mat-label>
        <textarea matInput formControlName="comment"></textarea>
        <mat-error *ngIf="questionGroup.get('comment')?.hasError('required')">
          Comment is required when selecting "Yes".
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</div>
